module.exports = __webpack_public_path__ + "img/04.d79ab859.png";